const TaskBarText = (task: any) => {
  return `<span bar-task-id="${task.id}">
      ${task.text}
    </span>`;
};

export default TaskBarText;
